<template>
    <div class="breadcrumb-list">
        <div :class="`breadcrumb-item ${key === list.length -1 ? 'breadcrumb-item-end' : ''}`" v-for="(item, key) in list" :key="key">{{key > 0 ? ' > ' : ''}}{{item.name}}</div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: {
        list: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    model: {
        "prop": "value",
        "event": 'change'
	},
	methods: {
		
	}
}
</script>

<style lang="scss" scoped>
.breadcrumb-list {
    z-index: 3;
    position: relative;
	height: 52px;
    min-height: 52px;
	display: flex;
	flex-direction: row;
	align-items: center;
	.breadcrumb-item {
		font-size: 12px;
		color: #999;
	}
	.breadcrumb-item-end {
		color: #2F3B47;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/breadcrumb/breadcrumb.vue